import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { roleNameFromRoleType } from '@euler/functions/user/util';
import {
  CoachingCaseFormat,
  CoachingSuggestion,
  CoachingSuggestionReasonKind,
} from '@euler/model/coaching';
import { BookOpen, IdCard, Target } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { formatName, turnsLabel } from '../../../copy';
import { ReportSection } from './ReportSection';

/** One practice to do next, with why it was picked. */
export const NextPracticeCard = memo(
  ({
    suggestion,
    onPress,
  }: {
    suggestion: CoachingSuggestion;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { reason, case: card } = suggestion;
    const Icon =
      reason.kind === CoachingSuggestionReasonKind.CollectionNext
        ? BookOpen
        : reason.kind === CoachingSuggestionReasonKind.WeakestArea
        ? Target
        : IdCard;
    const why =
      reason.kind === CoachingSuggestionReasonKind.CollectionNext
        ? `「${reason.collection.name}」合集的下一课`
        : reason.kind === CoachingSuggestionReasonKind.WeakestArea
        ? `针对你较弱的「${reason.area.name}」`
        : `适合你的岗位：${roleNameFromRoleType(reason.role)}`;
    return (
      <ReportSection style={{ gap: 0 }}>
        <View
          style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(6) }}
        >
          <Icon size={rpx(14)} color={aiColors.mutedForeground} />
          <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
            {why}
          </Typography.Text>
        </View>
        <Typography.Text
          size={rpx(14)}
          bold
          color={aiColors.foreground}
          style={{ marginTop: rpx(8) }}
        >
          {card.title}
        </Typography.Text>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ marginTop: rpx(4) }}
        >
          {`${formatName(card.format)} · ${turnsLabel(card.expectedTurns)}`}
        </Typography.Text>
        <TouchableOpacity
          accessibilityRole="button"
          onPress={onPress}
          style={{
            marginTop: rpx(12),
            height: rpx(36),
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: rpx(10),
            backgroundColor: aiColors.secondary,
          }}
        >
          <Typography.Text size={rpx(14)} bold color={aiColors.primary}>
            {card.format === CoachingCaseFormat.Drill ? '开始小练' : '开始练习'}
          </Typography.Text>
        </TouchableOpacity>
      </ReportSection>
    );
  },
);
